var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUboraHealthLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 418,
    viewBox: "0 0 455 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.204 297.699L62.7041 152.199L98.2041 114.199L154.204 170.699L231.704 95.6992L178.704 43.6992L223.704 0.699219L453.704 231.199L409.204 276.199L274.704 141.199L195.704 217.699L274.704 297.699C254.662 313 231.204 315.699 205.204 297.699Z",
    fill: "#7E7E7C",
    stroke: "#7A7979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.204 396.699L0.704102 217.699L47.2041 169.699C47.2041 169.699 175.704 314.729 219.204 335.199C262.704 355.67 305.704 295.199 303.204 292.199C300.704 289.199 226.204 212.199 226.204 212.199L274.204 169.699L394.204 298.699C394.204 298.699 295.204 396.699 278.204 407.199C261.204 417.699 248.704 418.699 226.704 416.199C204.704 413.699 182.204 396.699 182.204 396.699Z",
    fill: "#367398",
    stroke: "#2F78A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUboraHealthLogo);
export default __webpack_public_path__ + "static/media/Ubora_Health_Logo.0b0b76c1dc8f618fb592286da4e8a19b.svg";
export { ForwardRef as ReactComponent };